import React, { useState } from 'react';
import axios from 'axios';

import { formatStores } from 'appointment-tool/utils';
import { EView } from 'appointment-tool/constants/views';

import { IStore, IAvailableStore, ILocation } from '../types';
import { MOBILE_BREAKPOINT_PX } from '../constants';

interface IStateContext {
    availableStores?: IAvailableStore[];
    availableStoresError: boolean;
    centerLocation?: ILocation;
    findingCurrentLocation: boolean;
    isMobile?: boolean;
    searchInputValue: string;
    showMobileMap: boolean;
    searchLocation?: ILocation;
    searchTerm?: string;
    selectedStore?: IAvailableStore;
    useCurrentLocation: boolean;
    view: EView;
    fetchAvailableStores(): void;
    setAvailableStores(stores: IAvailableStore[]): void;
    setAvailableStoresError(value: boolean): void;
    setCenterLocation(location: ILocation): void;
    setFindingCurrentLocation(value: boolean): void;
    setIsMobile(value: boolean): void;
    setSearchInputValue(value: string): void;
    setShowMobileMap(value: boolean): void;
    setSearchLocation(location: ILocation | undefined): void;
    setSearchTerm(value: string): void;
    setSelectedStore(store: IAvailableStore | undefined): void;
    setUseCurrentLocation(value: boolean): void;
    setView(view: EView): void;
}

export const StateContext = React.createContext<IStateContext | undefined>(
    undefined
);

export const StateProvider: React.FC = ({ children }) => {
    const [availableStores, setAvailableStores] = useState<
        IAvailableStore[] | undefined
    >();
    const [availableStoresError, setAvailableStoresError] = useState(false);
    const [centerLocation, setCenterLocation] = useState<
        ILocation | undefined
    >();
    const [findingCurrentLocation, setFindingCurrentLocation] = useState(false);
    const [isMobile, setIsMobile] = useState<boolean | undefined>();
    const [searchInputValue, setSearchInputValue] = useState('');
    const [showMobileMap, setShowMobileMap] = useState(false);
    const [searchLocation, setSearchLocation] = useState<
        ILocation | undefined
    >();
    const [searchTerm, setSearchTerm] = useState<string | undefined>();
    const [selectedStore, setSelectedStore] = useState<
        IAvailableStore | undefined
    >();
    const [useCurrentLocation, setUseCurrentLocation] = useState(false);
    const [view, setView] = useState(EView.StoreList);

    const fetchAvailableStores = () => {
        axios
            .get<IStore[]>(process.env.REACT_APP_STORES_JSON_URL || '')
            .then(({ data }) => {
                const availableStores = formatStores(data);

                setAvailableStores(availableStores);
                setIsMobile(window.innerWidth < MOBILE_BREAKPOINT_PX);
            })
            .catch(() => {
                setAvailableStoresError(true);
                setIsMobile(window.innerWidth < MOBILE_BREAKPOINT_PX);
            });
    };

    return (
        <StateContext.Provider
            value={{
                availableStores,
                availableStoresError,
                centerLocation,
                findingCurrentLocation,
                isMobile,
                searchInputValue,
                showMobileMap,
                searchLocation,
                searchTerm,
                selectedStore,
                useCurrentLocation,
                view,
                fetchAvailableStores,
                setAvailableStores,
                setCenterLocation,
                setFindingCurrentLocation,
                setIsMobile,
                setSearchInputValue,
                setShowMobileMap,
                setSearchLocation,
                setSearchTerm,
                setSelectedStore,
                setUseCurrentLocation,
                setView,
                setAvailableStoresError,
            }}
        >
            {children}
        </StateContext.Provider>
    );
};
